<app-carousel-banner></app-carousel-banner>
<app-content-card></app-content-card>
<app-content-area></app-content-area>
<app-carousel-card></app-carousel-card>
<!-- <app-carousel-card1></app-carousel-card1> -->
<app-content-area2 [solutionData]="solutionData"></app-content-area2>
<app-tab-content></app-tab-content>
<app-tab-content1></app-tab-content1>
<!-- <app-carousel-card2></app-carousel-card2> -->
@if (homeFormConfig) {
<section class="spacer-pt-space spacer-pb-space bg-black">
    <div class="container">
        <div class="row gap-y-10 md:flex-row-reverse">
            <div class="col-md-6 xl:pl-20">
                <h2 class="heading-primary-8xl mb-6 text-white xl:mb-[46px]">What's Next?</h2>
                <ul class="contentList">
                    @for (item of listdata; track $index) {
                        <li>{{item.listtext}}</li>
                    }
                </ul>
                <a type="button" routerLink="contact-us" (click)="handler_redirect(2)" title="Let's talk"
                    class="button button-orange button-rounded button-arrow mt-4 md:mt-8">Let's talk</a>
            </div>
            <div class="col-md-6">
                <div class="p-6 bg-white rounded-[6px] xl:p-[42px] xl:rounded-[10px]">
                    @if (homeFormTitle) {
                        <h2 class="heading-primary-8xl !mb-6 xl:!mb-[46px]">{{homeFormTitle}}</h2>
                    } @else {
                        <h2 class="heading-primary-8xl !mb-6 xl:!mb-[46px]">Request a <u class="after:!z-[1]"><span class="relative z-[2]">Call Back</span></u></h2>
                    }
                    <app-dynamic-form
                        [formConfig]="homeFormConfig"
                        [submitButtonText]="'Get in Touch'"
                        [submittingButtonText]="'Submitting...'"
                    ></app-dynamic-form>
                </div>
            </div>
        </div>
    </div>
</section>
}